module.exports = __webpack_public_path__ + "img/Bean-2.82215a26.svg";